import { createI18n } from 'vue-i18n';
import en from './lang/en-US.json';

export const stringMapper: object = {
  de: 'de-DE',
  en: 'en-US',
  nl: 'nl-NL',
  fr: 'fr-FR',
  it: 'it-IT',
  es: 'es-ES',
  pt: 'pt-PT',
  da: 'da-DK',
  pl: 'pl-PL',
  cs: 'cs-CZ'
};

const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en },
  silentTranslationWarn: import.meta.env.VUE_APP_ENV != 'dev',
  warnHtmlMessage: false
});

export async function setLanguage(lang: string) {
  //Check if the lang is supported otherwise fallback en
  const chooseLang = Object.keys(stringMapper).includes(lang) ? lang : 'en';

  const messages = await import(`./lang/${stringMapper[chooseLang as keyof typeof stringMapper]}.json`);
  i18n.global.setLocaleMessage(chooseLang, messages.default);
  i18n.global.locale.value = chooseLang as keyof typeof stringMapper;
}

export default i18n;
